import { render, staticRenderFns } from "./weibo.vue?vue&type=template&id=ca02050a&scoped=true"
import script from "./weibo.vue?vue&type=script&lang=js"
export * from "./weibo.vue?vue&type=script&lang=js"
import style0 from "./weibo.vue?vue&type=style&index=0&id=ca02050a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca02050a",
  null
  
)

export default component.exports